import { Component, inject } from '@angular/core';
import { MaterialCreateDto, MaterialDto, MaterialExcelDownloadDto, MaterialService, MaterialUpdateDto } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { MATERIAL_CONFIG, MATERIAL_FIELDS } from './material.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-material',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MaterialService, ConfirmationService],
  templateUrl: './material.html',
  styleUrl: './material.scss',
})
export class Material extends BaseHierarchicalCrudComponent<
  MaterialDto,
  MaterialCreateDto,
  MaterialUpdateDto,
  MaterialExcelDownloadDto
> {
  service = inject(MaterialService);
  config = MATERIAL_CONFIG;
  fields = MATERIAL_FIELDS;

  protected prepareUpdateDto(data: any, selected: MaterialDto): MaterialUpdateDto {
    return {
      materialTypeId: data.materialTypeId,
      consumableId: data.consumableId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Material';
  }
}
